export const permissionObj = {
    WEB_COMPANY_MENU: 100,
    WEB_COMPANY_READ: 101,
    WEB_COMPANY_UPDATE: 102,
    WEB_PROFILE_READ: 110,
    WEB_PROFILE_UPDATE: 111,
    WEB_EMPLOYEE_MENU: 120,
    WEB_EMPLOYEE_READ: 121,
    WEB_EMPLOYEE_CREATE: 122,
    WEB_EMPLOYEE_UPDATE: 123,
    WEB_EMPLOYEE_DELETE: 124,
    WEB_EMPLOYEE_EXPORT: 125,
    WEB_VCARD_SETTINGS_UPDATE: 126,
    WEB_HEADERS_UPDATE: 127,
    WEB_USER_RESTRICTION_UPDATE: 128,
    WEB_EMPLOYEE_IMPORT: 129,
    WEB_EMPLOYEE_DOCUMENT_MENU: 130,
    WEB_EMPLOYEE_DOCUMENT_READ: 131,
    WEB_EMPLOYEE_DOCUMENT_CREATE: 132,
    WEB_EMPLOYEE_DOCUMENT_UPDATE: 133,
    WEB_EMPLOYEE_DOCUMENT_DELETE: 134,
    WEB_EMPLOYEE_CAN_MANAGE_PASSWORDS:135,
    WEB_SUPPLIER_DOCUMENT_MENU: 140,
    WEB_SUPPLIER_DOCUMENT_READ: 141,
    WEB_SUPPLIER_DOCUMENT_CREATE: 142,
    WEB_SUPPLIER_DOCUMENT_UPDATE: 143,
    WEB_SUPPLIER_DOCUMENT_DELETE: 144,
    WEB_CONTRACTOR_DOCUMENT_MENU: 145,
    WEB_SUPPLIER_VEHICLE_DOCUMENT_MENU: 150,
    WEB_SUPPLIER_VEHICLE_DOCUMENT_READ: 151,
    WEB_SUPPLIER_VEHICLE_DOCUMENT_CREATE: 152,
    WEB_SUPPLIER_VEHICLE_DOCUMENT_UPDATE: 153,
    WEB_SUPPLIER_VEHICLE_DOCUMENT_DELETE: 154,
    WEB_CONTRACTOR_VEHICLE_DOCUMENT_MENU: 155,
    WEB_WORK_SHIFT_MENU: 160,
    WEB_WORK_SHIFT_READ: 161,
    WEB_WORK_SHIFT_CREATE: 162,
    WEB_WORK_SHIFT_UPDATE: 163,
    WEB_WORK_SHIFT_DELETE: 164,

    WEB_PRIVILEGE_MENU: 170,
    WEB_PRIVILEGE_READ: 171,
    WEB_PRIVILEGE_CREATE: 172,
    WEB_PRIVILEGE_UPDATE: 173,
    WEB_PRIVILEGE_DELETE: 174,
    WEB_PRIVILEGE_MANAGE_USERS: 175,
    WEB_VEHICLE_MENU: 180,
    WEB_VEHICLE_READ: 181,
    WEB_VEHICLE_CREATE: 182,
    WEB_VEHICLE_UPDATE: 183,
    WEB_VEHICLE_DELETE: 184,
    WEB_VEHICLE_EXPORT:185,
    WEB_VEHICLE_IMPORT:186,
    WEB_ZONE_MENU: 190,
    WEB_ZONE_READ: 191,
    WEB_ZONE_CREATE: 192,
    WEB_ZONE_UPDATE: 193,
    WEB_ZONE_DELETE: 194,
    WEB_ZONE_MANAGE_USERS: 195,
    WEB_ZONE_READ_DEVICES: 196,
    WEB_ZONE_CREATE_DEVICES: 197,
    WEB_ZONE_UPDATE_DEVICES: 198,
    WEB_ZONE_DELETE_DEVICES: 199,
    WEB_DEVICE_MENU: 200,
    WEB_DEVICE_READ: 201,
    WEB_DEVICE_CREATE: 202,
    WEB_DEVICE_UPDATE: 203,
    WEB_DEVICE_DELETE: 204,
    WEB_DEVICE_EXPORT: 205,
    WEB_DEVICE_OPEN_THE_DOOR_DEVICE: 206,
    WEB_DEVICE_RESTRICTION_UPDATE: 207,
    WEB_REPORTS_MENU: 210,
    WEB_REPORTS_READ: 211,
    WEB_REPORTS_CREATE: 212,
    WEB_REPORTS_UPDATE: 213,
    WEB_REPORTS_DELETE: 214,
    WEB_REPORTS_EXPORT: 215,
    WEB_BACK_UP_MENU: 220,
    WEB_BACK_UP_READ: 221,
    WEB_BACK_UP_CREATE: 222,
    WEB_BACK_UP_FULL_RESTORE: 223,
    WEB_BACK_UP_PARTIAL_RESTORE: 224,
    WEB_ONBOARDING_MENU: 240,
    WEB_ONBOARDING_CREATE: 241,
    WEB_ONBOARDING_UPDATE: 242,
    WEB_ONBOARDING_READ: 243,
    WEB_ONBOARDING_DELETE: 244,
    WEB_HOSPITALITY_MENU: 250,
    WEB_HOSPITALITY_CREATE: 251,
    WEB_HOSPITALITY_UPDATE: 252,
    WEB_HOSPITALITY_READ: 253,
    WEB_HOSPITALITY_DELETE: 254,
    WEB_EMAIL_SETTINGS_MENU: 260,
    WEB_EMAIL_SETTINGS_CREATE: 261,
    WEB_EMAIL_SETTINGS_UPDATE: 262,
    WEB_EMAIL_SETTINGS_READ: 263,
    WEB_ANNOUNCEMENT_MENU: 270,
    WEB_ANNOUNCEMENT_READ: 271,
    WEB_ANNOUNCEMENT_CREATE: 272,
    WEB_ANNOUNCEMENT_DELETE: 273,
    WEB_ANNOUNCEMENT_EXPORT: 274,
    WEB_ACCESS_USER_MENU: 290,
    WEB_ACCESS_USER_READ: 291,
    WEB_ACCESS_USER_EXPORT: 292,
    WEB_ACCESS_VEHICLE_MENU: 295,
    WEB_ACCESS_VEHICLE_READ: 296,
    WEB_ACCESS_VEHICLE_EXPORT: 297,
    WEB_SUPPLIER_MENU: 300,
    WEB_SUPPLIER_IMPORT: 312,
    WEB_SUPPLIER_CREATE: 301,
    WEB_SUPPLIER_UPDATE: 302,
    WEB_SUPPLIER_DELETE: 303,
    WEB_SUPPLIER_READ: 304,
    WEB_SUPPLIER_ORDER_READ: 306,
    WEB_SUPPLIER_ORDER_UPDATE: 307,
    WEB_SUPPLIER_ORDER_DELETE: 308,
    WEB_SUPPLIER_ORDER_CREATE: 309,
    WEB_SUPPLIER_EXPORT: 310,
    WEB_SUPPLIER_ORDER_EXPORT: 309,
    WEB_CONTRACTOR_MENU: 320,
    WEB_CONTRACTOR_CREATE: 321,
    WEB_CONTRACTOR_UPDATE: 322,
    WEB_CONTRACTOR_DELETE: 323,
    WEB_CONTRACTOR_READ: 324,
    WEB_CONTRACTOR_FORM: 325,
    WEB_CONTRACTOR_CONTRACT_READ: 326,
    WEB_CONTRACTOR_CONTRACT_UPDATE: 327,
    WEB_CONTRACTOR_CONTRACT_DELETE: 328,
    WEB_CONTRACTOR_CONTRACT_CREATE: 329,
    WEB_CONTRACTOR_CONTRACT_EXPORT: 330,
    WEB_CONTRACTOR_MANAGE_DOCUMENTS:331,
    WEB_CONTRACTOR_EXPORT: 332,
    WEB_CONTRACTOR_IMPORT: 333,
    WEB_CONTRACTOR_CONTRACT_MANAGE_USERS: 334,
    WEB_CONTRACTOR_CONTRACT_MANAGE_VEHICLES: 335,
    WEB_EVENT_MENU: 340,
    WEB_EVENT_READ: 341,
    WEB_EVENT_CREATE: 342,
    WEB_EVENT_UPDATE: 343,
    WEB_EVENT_DELETE: 344,
    WEB_EVENT_EXPORT: 345,
    WEB_EVENT_MANAGE_USERS: 346,
    WEB_EVENT_CANCEL: 347,
    WEB_ATTENDANCE_MENU: 350,
    WEB_ATTENDANCE_READ: 351,
    WEB_ATTENDANCE_CREATE: 352,
    WEB_ATTENDANCE_UPDATE: 353,
    WEB_ATTENDANCE_DELETE: 354,
    WEB_ATTENDANCE_EXPORT: 355,

    WEB_DEPARTMENT_MENU: 360,
    WEB_DEPARTMENT_READ: 361,
    WEB_DEPARTMENT_CREATE: 362,
    WEB_DEPARTMENT_UPDATE: 363,
    WEB_DEPARTMENT_DELETE: 364,
    WEB_HOLIDAY_MENU:370,
    WEB_HOLIDAY_READ: 371,
    WEB_HOLIDAY_CREATE: 372,
    WEB_HOLIDAY_UPDATE: 373,
    WEB_HOLIDAY_DELETE: 374,
    WEB_CARD_MENU: 380,
    WEB_CARD_READ: 381,
    WEB_CARD_CREATE: 382,
    WEB_CARD_DELETE: 384,
    WEB_CARD_EXPORT:385,
    WEB_CARD_MANAGE_TEMPLATES:386,
    WEB_CARD_MANAGE_USERS:387,
    WEB_HOME_OFFICE_MENU: 400,
    WEB_HOME_OFFICE_READ: 401,
    WEB_GUARD_MENU: 410,
    WEB_GUARD_READ: 411,
    WEB_LOG_PLATFORM_MENU: 420,
    WEB_LOG_PLATFORM_READ: 421,
    WEB_LOG_PLATFORM_EXPORT: 422,
    WEB_LOG_ACTION_MENU: 425,
    WEB_LOG_ACTION_READ: 426,
    WEB_LOG_ACTION_EXPORT: 427,
    WEB_CARD_DESIGNER_MENU: 430,
    WEB_CARD_DESIGNER_READ: 431,
    WEB_CARD_DESIGNER_CREATE: 432,
    WEB_CARD_DESIGNER_UPDATE: 433,
    WEB_CARD_DESIGNER_DELETE: 434,
    WEB_RESOURCES_MENU: 450,
    WEB_RESOURCES_READ: 451,
    WEB_RESOURCES_CREATE: 452,
    WEB_RESOURCES_UPDATE: 453,
    WEB_RESOURCES_DELETE: 454,
    WEB_HID_MENU: 460,
    WEB_HID_READ: 461,
    WEB_HID_CREATE: 462,
    WEB_HID_UPDATE: 463,
    WEB_HID_DELETE: 464,
    WEB_CHART_MENU: 470,
    WEB_CHART_READ: 471,
    WEB_CHART_CREATE: 472,
    WEB_CHART_UPDATE: 473,
    WEB_CHART_DELETE: 474,
    WEB_HARD_DELETE_MENU: 481,
    WEB_HARD_DELETE_READ: 482,
    WEB_HARD_DELETE_RECOVER: 483,
    WEB_HARD_DELETE_DELETE: 484,
    WEB_SUPPLIER_RESTRICTION_UPDATE: 491,
    WEB_EMPLOYEE_DOCUMENT_RESTRICTION_UPDATE: 492,
    WEB_SUPPLIER_DOCUMENT_RESTRICTION_UPDATE: 493,
    WEB_CONTRACTOR_DOCUMENT_RESTRICTION_UPDATE: 494,
    WEB_CONTRACTOR_DOCUMENT_VEHICLE_RESTRICTION_UPDATE: 495,
    WEB_SUPPLIER_DOCUMENT_VEHICLE_RESTRICTION_UPDATE: 496,
    WEB_SYSTEM_CONFIG_READ: 500,
    WEB_SYSTEM_CONFIG_CREATE: 501,
    WEB_SYSTEM_CONFIG_UPDATE: 502,
    WEB_SYSTEM_CONFIG_DELETE: 503,

    WEB_APPROVAL_FLOW_READ: 510,
    WEB_APPROVAL_FLOW_CREATE: 511,
    WEB_APPROVAL_FLOW_UPDATE: 512,
    WEB_APPROVAL_FLOW_DELETE: 513,

    // Visitor Type Permissions (520-530)
    WEB_VISITOR_TYPE_READ: 520,
    WEB_VISITOR_TYPE_CREATE: 521,
    WEB_VISITOR_TYPE_UPDATE: 522,
    WEB_VISITOR_TYPE_DELETE: 523,

    WEB_INGREDIENT_READ: 530,
    WEB_INGREDIENT_CREATE: 531,
    WEB_INGREDIENT_UPDATE: 532,
    WEB_INGREDIENT_DELETE: 533,
    WEB_INGREDIENT_EXPORT: 534,

    WEB_FOODIE_ITEM_READ: 540,
    WEB_FOODIE_ITEM_CREATE: 541,
    WEB_FOODIE_ITEM_UPDATE: 542,
    WEB_FOODIE_ITEM_DELETE: 543,
    WEB_FOODIE_ITEM_EXPORT: 544,

    WEB_FOODIE_MENU_READ: 550,
    WEB_FOODIE_MENU_CREATE: 551,
    WEB_FOODIE_MENU_UPDATE: 552,
    WEB_FOODIE_MENU_DELETE: 553,
    WEB_FOODIE_MENU_EXPORT: 554,
    WEB_FOODIE_MENU_CLONE: 555,

    WEB_FOODIE_CAFETERIA_READ: 560,
    WEB_FOODIE_CAFETERIA_CREATE: 561,
    WEB_FOODIE_CAFETERIA_UPDATE: 562,
    WEB_FOODIE_CAFETERIA_DELETE: 563,
    WEB_FOODIE_CAFETERIA_EXPORT: 564,

    WEB_FOODIE_SHIFT_READ: 570,
    WEB_FOODIE_SHIFT_CREATE: 571,
    WEB_FOODIE_SHIFT_UPDATE: 572,
    WEB_FOODIE_SHIFT_DELETE: 573,

    // ---580 to 589----------- SERVICE TYPE //
    WEB_SERVICE_TYPE_READ:580,
    WEB_SERVICE_TYPE_CREATE:581,
    WEB_SERVICE_TYPE_UPDATE:582,
    WEB_SERVICE_TYPE_DELETE:583,
    // ---590 to 599----------- DISTRIBUTION CENTER //
    WEB_DISTRIBUTION_CENTER_READ:590,
    WEB_DISTRIBUTION_CENTER_CREATE:591,
    WEB_DISTRIBUTION_CENTER_UPDATE:592,
    WEB_DISTRIBUTION_CENTER_DELETE:593,
    // ---600 to 609----------- DISTRIBUTION CENTER //
    WEB_LOGISTIC_REQUEST_READ:600,
    WEB_LOGISTIC_REQUEST_CREATE:601,
    WEB_LOGISTIC_REQUEST_UPDATE:602,
    WEB_LOGISTIC_REQUEST_DELETE:603,
    WEB_LOGISTIC_REQUEST_EXPORT:604,

    WEB_FOODIE_MENU_SELECTION_VIEW: 610,
    WEB_FOODIE_MENU_SELECTION_CREATE: 611,
    WEB_FOODIE_MENU_SELECTION_UPDATE: 612,
    // ---620 to 622----------- FOODIE_EXTRA_REQUEST//
    WEB_FOODIE_EXTRA_REQUEST_VIEW: 620,
    WEB_FOODIE_EXTRA_REQUEST_CREATE: 621,
    WEB_FOODIE_EXTRA_REQUEST_UPDATE:622,
    WEB_FOODIE_EXTRA_REQUEST_DELETE:623,
    WEB_FOODIE_EXTRA_REQUEST_EXPORT:624,
    // ---630 to 639----------- FOODIE_MEAL_TIME //
    WEB_FOODIE_MEAL_TIME_READ: 630,
    WEB_FOODIE_MEAL_TIME_CREATE: 631,
    WEB_FOODIE_MEAL_TIME_UPDATE: 632,
    WEB_FOODIE_MEAL_TIME_DELETE: 633,
    // ---640 to 649----------- FOODIE_DEPARTMENT_POLICIES //
    WEB_FOODIE_DEPARTMENT_POLICIES_READ :640,
    WEB_FOODIE_DEPARTMENT_POLICIES_CREATE:641,
    WEB_FOODIE_DEPARTMENT_POLICIES_UPDATE:642,
    WEB_FOODIE_DEPARTMENT_POLICIES_DELETE:643,

    // ---650 to 659----------- VISITOR_INVITATION //
    WEB_VISITOR_INVITATION_READ:650,
    WEB_VISITOR_INVITATION_CREATE:651,
    WEB_VISITOR_INVITATION_UPDATE:652,
    WEB_VISITOR_INVITATION_DELETE:653,
    WEB_VISITOR_INVITATION_EXPORT:654,
    WEB_VISITOR_INVITATION_MANAGE:655,

    // ---660 to 669----------- VISITOR_REQUEST //
    WEB_VISITOR_REQUEST_READ: 660,
    WEB_VISITOR_REQUEST_DELETE: 661,
    WEB_VISITOR_INVITATION_STATUS_READ: 662,
    WEB_VISITOR_REQUEST_EXPORT: 663,
    WEB_VISITOR_INVITATION_STATUS_EXPORT: 664,
    WEB_VISITOR_INVITATION_STATUS_DOCUMENTATION_READ: 665,
    WEB_VISITOR_INVITATION_STATUS_DOCUMENTATION_MANAGE: 666,
    WEB_VISITOR_INVITATION_STATUS_IDENTIFY_READ: 667,
    WEB_VISITOR_INVITATION_STATUS_IDENTIFY_MANAGE: 668,

    // ---670 to 679----------- VISITOR //
    WEB_VISITOR_READ: 670,
    WEB_VISITOR_CREATE: 671,
    WEB_VISITOR_UPDATE: 672,
    WEB_VISITOR_DELETE: 673,
    WEB_VISITOR_EXPORT: 674,

    // --- 680 to 684 -----------   KITCHEN_TICKETS
    WEB_KITCHEN_TICKETS_READ: 680,
    WEB_KITCHEN_TICKETS_CREATE: 681,
    // --- 685 to 689 ----------- KITCHEN_TICKETS_HISTORY
    WEB_KITCHEN_TICKETS_HISTORY_READ: 685,
    // --- 696 ----------- FOODIE REQUEST
    WEB_FOODIE_REQUEST_READ: 695,
    WEB_FOODIE_REQUEST_EXPORT: 696,

    //--- 690 to 699------- FOODIE ATTENDANCE
    WEB_FOODIE_ATTENDANCE_READ: 690,
    WEB_FOODIE_ATTENDANCE_EXPORT: 691,

    // ---700 to 709----------- REQUEST ACCESS  //
    WEB_REQUEST_ACCESS_READ: 700,
    WEB_REQUEST_ACCESS_MANAGE: 705,

    // ---710 to 719----------- INCOMING INVITATION  //
    WEB_VISITOR_INCOMING_INVITATION_READ: 710,
    WEB_VISITOR_INCOMING_INVITATION_EXPORT: 714,
    WEB_VISITOR_INCOMING_INVITATION_MANAGE: 715,

    // ---720 to 729----------- TOTAL MEALS  //
    WEB_TOTAL_MEALS_READ : 720,
    WEB_TOTAL_MEALS_EXPORT : 721,

    // ---730 to 739 ---------  MEAL FORECAST
    WEB_FOODIE_MEAL_FORECAST_READ: 730,
    WEB_FOODIE_MEAL_FORECAST_EXPORT: 731,

    // ---740 to 749----------- ACCESS CODE  //
    WEB_FOODIE_ACCESS_READ: 740,
    WEB_FOODIE_ACCESS_CREATE: 741,
    WEB_FOODIE_ACCESS_CANCEL: 742,
    WEB_FOODIE_ACCESS_DELETE: 743,

    // ---740 to 749----------- FINE TYPE  //
    WEB_FINE_TYPE_READ : 750,
    WEB_FINE_TYPE_CREATE : 751,
    WEB_FINE_TYPE_UPDATE : 752,
    WEB_FINE_TYPE_DELETE : 753,

    // ---760 to 764 ----------- TRAFFIC_DASHBOARD_GEOFENCES 81 //
    WEB_TRAFFIC_DASHBOARD_GEOFENCES_READ : 760,

    // ---765 to 769 ----------- TRAFFIC_DASHBOARD_FINES 82 //
    WEB_TRAFFIC_DASHBOARD_FINES_READ : 765,
    WEB_TRAFFIC_DASHBOARD_FINES_CREATE : 766,
    WEB_TRAFFIC_DASHBOARD_FINES_EXPORT: 767,

    // ---770 to 774 ----------- TRAFFIC_USERS 83 //
    WEB_TRAFFIC_USERS_READ : 770,
    WEB_TRAFFIC_USERS_MANAGE_PAYMENT : 771,
    WEB_TRAFFIC_USERS_EXPORT: 772,

    // ---775 to 779 ----------- TRAFFIC_MANAGE_FINES 84 //
    WEB_TRAFFIC_MANAGE_FINES_READ : 775,
    WEB_TRAFFIC_MANAGE_FINES_UPDATE : 776,

    // ---780 to 784 ----------- TRAFFIC_MANAGE_GEOFENCES 85 //
    WEB_TRAFFIC_MANAGE_GEOFENCES_READ : 780,
    WEB_TRAFFIC_MANAGE_GEOFENCES_CREATE : 781,
    WEB_TRAFFIC_MANAGE_GEOFENCES_UPDATE : 782,
    WEB_TRAFFIC_MANAGE_GEOFENCES_DELETE : 783,

    // ----------790 to 799----------EVENT_STATUS 86 //
    WEB_EVENT_STATUS_READ : 790,
    WEB_EVENT_STATUS_UPDATE : 791,
    WEB_EVENT_STATUS_DELETE : 792,
    WEB_EVENT_STATUS_EXPORT : 793,
    WEB_EVENT_STATUS_CANCEL : 794,

    // ----------800 to 809 ----------------------//
    WEB_CONTRACTOR_APPROVAL_FLOW_READ: 800,
    WEB_CONTRACTOR_APPROVAL_FLOW_CREATE: 801,
    WEB_CONTRACTOR_APPROVAL_FLOW_UPDATE: 802,
    WEB_CONTRACTOR_APPROVAL_FLOW_DELETE: 803,

    // ----------810 to 811----------EVENT_MANAGE 86 //
    WEB_EVENT_MANAGE_READ : 810,
    WEB_EVENT_MANAGE_UPDATE : 811,

    // ----------820 to 829----------CONTRACTOR_MANAGE 89 //
    WEB_CONTRACTOR_MANAGE_READ : 820,
    WEB_CONTRACTOR_MANAGE_UPDATE: 821,
    // ----------830 to 839 ----------------------//
    WEB_SUPPLIER_APPROVAL_FLOW_READ: 830,
    WEB_SUPPLIER_APPROVAL_FLOW_CREATE: 831,
    WEB_SUPPLIER_APPROVAL_FLOW_UPDATE: 832,
    WEB_SUPPLIER_APPROVAL_FLOW_DELETE: 833,

    // ----------840 to 849----------CONTRACTOR_MANAGE 91 //
    WEB_SUPPLIER_MANAGE_READ : 840,
    WEB_SUPPLIER_MANAGE_UPDATE: 841,

    // ----------850 to 859 ----------- GUARD INCOMING CONTRACTORS //
    WEB_CONTRACTOR_INCOMING_READ :710,
    WEB_CONTRACTOR_INCOMING_UPDATE :710,


    WEB_ATTENDANCE_SHIFT_READ:870,
    WEB_ATTENDANCE_SHIFT_CREATE:871,
    WEB_ATTENDANCE_SHIFT_UPDATE:872,
    WEB_ATTENDANCE_SHIFT_DELETE:873,
    WEB_ATTENDANCE_SETTING_READ:876,
    WEB_ATTENDANCE_SETTING_UPDATE:877,

    WEB_ATTENDANCE_DEPARTMENT_POLICIES_READ: 880,
    WEB_ATTENDANCE_DEPARTMENT_POLICIES_CREATE: 881,
    WEB_ATTENDANCE_DEPARTMENT_POLICIES_UPDATE: 882,
    WEB_ATTENDANCE_DEPARTMENT_POLICIES_DELETE: 883,

    // ------------890 to 899 ------------------ // CONTRACTOR REQUEST
    WEB_CONTRACTOR_REQUEST_READ : 890,
    WEB_CONTRACTOR_REQUEST_MANAGE: 891,

    // ------------900 to 909 ------------------ // SUPPLIER REQUEST
    WEB_SUPPLIER_REQUEST_READ : 900,
    WEB_SUPPLIER_REQUEST_MANAGE: 901,

    // --- 910 to 919 -----------   KITCHEN ACCESS
    WEB_FOODIE_KITCHEN_ACCESS_READ:910,
    WEB_FOODIE_KITCHEN_ACCESS_CREATE:911,
    WEB_FOODIE_KITCHEN_ACCESS_UPDATE:912,
    WEB_FOODIE_KITCHEN_ACCESS_DELETE:913,
    WEB_FOODIE_KITCHEN_ACCESS_EXPORT: 914,

    // --- 920 to 929 -----------   KITCHEN ACCESS HISTORY
    WEB_FOODIE_KITCHEN_ACCESS_HISTORY_READ:920,
    WEB_FOODIE_KITCHEN_ACCESS_HISTORY_CREATE:921,
    WEB_FOODIE_KITCHEN_ACCESS_HISTORY_UPDATE:922,
    WEB_FOODIE_KITCHEN_ACCESS_HISTORY_DELETE:923,
    WEB_FOODIE_KITCHEN_ACCESS_HISTORY_EXPORT:924,

     // ------------930 to 933 ------------------ // FOODIE MANAGE SETTINGS
    WEB_FOODIE_MANAGE_SETTINGS_READ: 930,
    WEB_FOODIE_MANAGE_SETTINGS_CREATE:931,
    WEB_FOODIE_MANAGE_SETTINGS_UPDATE: 932,
    WEB_FOODIE_MANAGE_SETTINGS_DELETE: 933,

}
